import { render } from "./PollComments.vue?vue&type=template&id=663896e6"
import script from "./PollComments.vue?vue&type=script&lang=js"
export * from "./PollComments.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/poll/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/polls/partials/PollComments.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "663896e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('663896e6', __exports__)) {
    console.log('reload')
    api.reload('663896e6', __exports__)
  }
  
  module.hot.accept("./PollComments.vue?vue&type=template&id=663896e6", () => {
    console.log('re-render')
    api.rerender('663896e6', render)
  })

}


export default __exports__